export const getStyled = (theme) => ({
  tagFilter: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.custom.colors.text,
        color: theme.palette.mode === 'light' ? '#999999' : '#bdbdbd',
      },

      '&:hover fieldset': {
        borderColor: theme.custom.colors.text,
        color: theme.palette.mode === 'light' ? '#999999' : '#bdbdbd',
      },

      '&.Mui-focused fieldset': {
        borderColor: theme.custom.colors.text,
        color: theme.palette.mode === 'light' ? '#999999' : '#bdbdbd',
      },
    },

    '& .MuiInputBase-root': {
      color: `${theme.custom.colors.text} !important`,
      backgroundColor: theme.custom.colors.total,
    },
  },

  chip: {
    color: '#FFF',
    marginRight: 4,
    padding: '2px 5px',
    fontWeight: 'bold',
    borderRadius: 3,
    fontSize: '0.8em',
    whiteSpace: 'nowrap',
  },
});
